define(
  'app/views/newsletter_popup_view',['app/setup', 'app/views/newsletter_view'],
  function(takhfifan, newsletterView) {

  takhfifan.NewsletterPopupView = takhfifan.NewsletterView.extend({

    events: {
      'click  .modal-close': 'close',
      'submit': 'submit',
      'click li': 'setCity'
    },

    initialize: function(options) {
      var _this = this;
      _this.optinConfirm = true;

      takhfifan.eventHub.on('overlay:blur', function() {
        _this.closeByOverlay();
      }, this);

      this.cookie_success = 'subscribed';
      this.cookie_closed = 'subscription_box_close';

      this.model.on('newsletter:loading', this.loading, this);
      this.model.on('submit:success', this.success, this);
      this.model.on('submit:invalid', this.renderErrors, this);
      Backbone.Validation.bind(this);
      this.checkParams();
      takhfifan.eventHub.on('newsletter:doubleOptinNotConfirm', function() {
        _this.optinConfirm = false;
        this.render();
      }, this);
    },

    render: function() {
      var _this = this;
      var closed = $.cookie(this.cookie_closed);
      var success = $.cookie(this.cookie_success);
      var allowed = _.isNull(
        document.location.pathname.match(/\/checkout\//)
      );
      var wideEnough = $(window).width() > 979;
      if (allowed && wideEnough && (success != 'true') && (closed != 'true') && !_this.optinConfirm) {
        $('.modal-overlay').show();
        this.$('.subscribe-box').show();
        var $bnrImg = this.$('.bnr-wrp img');
        $bnrImg.attr('src', $bnrImg.data('src'));
      }
      // else if(allowed && !(wideEnough) && (success != 'true') && (closed != 'true') && !_this.optinConfirm) {
      //   $('.modal-overlay').show();
      //   this.$('.subscribe-box-mobile').show();
      // }
    },

    checkParams: function() {
      if (this.urlParam('skipModal') == 1) {
        var expires = ($.cookie(this.cookie_success) == 'true') ? 28 : 1;
        this.setCookie({ expires: expires, name: this.cookie_closed });
      }
    },

    closeByOverlay: function() {
      var expires = ($.cookie(this.cookie_success) == 'true') ? 28 : 1;
      this.$el.fadeOut('slow');
      this.setCookie({ expires: expires, name: this.cookie_closed });
      return false;
    },

    close: function(e) {
      e.preventDefault();
      var expires = ($.cookie(this.cookie_success) == 'true') ? 28 : 1;

      this.$el.fadeOut('slow');
      $('.modal-overlay').fadeOut('slow');

      this.setCookie({ expires: expires, name: this.cookie_closed });
      return false;
    },

    loading: function() {
      this.$('button').html('<span class="spinner"></span>');
    },

    success: function() {
      this.$('.error').empty().hide();
      this.$('.subscribe-box').hide();
      this.$('.success').addClass('after-login').show();
      this.$('button').html('مشاهده تخفیف ها');
      this.setCookie({
        name: this.cookie_success,
        expires: 28
      });

      takhfifan.eventHub.trigger('trackPopupSubscription:subscribe');

      _.delay(function($el){
        $el.fadeOut('slow');
        $('.modal-overlay').fadeOut('slow');
      }, 2000, this.$el);
    }

  });
});

